import React, { Component } from "react";
import { Link } from "react-router-dom";

// Layout
import Header from "../layout/header/header1";

// Images
import bannerImg from "../../images/banner/banner3.jpg";
import news23_1 from "../../images/news/news23_1.jpg";
import news23_2 from "../../images/news/news23_2.jpg";
import news23_3 from "../../images/news/news23_3.jpg";
import news23_4 from "../../images/news/news23_4.jpg";
import news23_5 from "../../images/news/news23_5.jpg";
import news23_6 from "../../images/news/news23_6.jpg";
import news23_7 from "../../images/news/news23_7.jpg";
import news23_8 from "../../images/news/news23_8.jpg";
import news23_9 from "../../images/news/news23_9.jpg";
import news23_10 from "../../images/news/news23_10.jpg";
import news23_11 from "../../images/news/news23_11.jpg";
import news23_12 from "../../images/news/news23_12.jpg";
import news23_13 from "../../images/news/news23_13.jpg";
import news23_14 from "../../images/news/news23_14.jpg";
import news23_15 from "../../images/news/news23_15.jpg";

import { withTranslation } from "react-i18next";
import ReactMarkdown from "react-markdown";

class news23 extends Component {
    componentDidMount() { }

    componentWillMount() {
        const { t } = this.props;
        document.getElementById("title").innerText = t("News23_Title");
    }

    componentWillUnmount() {
        const { t } = this.props;
        document.getElementById("title").innerText = t("Home_Title");
    }

    render() {
        const { t } = this.props;

        return (
            <>
                <Header />

                <div className="page-content">
                    <div
                        className="page-banner ovbl-dark"
                        style={{ backgroundImage: "url(" + bannerImg + ")" }}
                    >
                        <div className="container">
                            <div className="page-banner-entry">
                                <h1 className="text-white">{t("News23_Title")}</h1>
                            </div>
                        </div>
                    </div>

                    <div className="breadcrumb-row">
                        <div className="container">
                            <ul className="list-inline">
                                <li>
                                    <Link to="/">{t("News23_LinkHome")}</Link>
                                </li>
                                <li>{t("News23_LinkCourses")}</li>
                            </ul>
                        </div>
                    </div>

                    <div className="content-block">
                        <div className="section-area section-sp1">
                            <div className="container">
                                <div className="row d-flex flex-row-reverse">
                                    <div className="col-xl-9 col-lg-8 col-md-12 col-sm-12">
                                        <div className="courses-post">

                                            <h1>{t("News23_Content_H")}</h1>


                                            {/* P1 */}
                                            <ReactMarkdown>{t("News23_P1_MD")}</ReactMarkdown>

                                            {/* IMG 1 */}
                                            <div style={{ textAlign: "center", margin: "23px 0" }}>
                                                <img
                                                    src={news23_1}
                                                    alt={t("News23_IMG1_DESC")}
                                                />
                                                <div style={{ marginTop: "10px", fontStyle: "italic", color: "#555" }}>
                                                    {t("News23_IMG1_DESC")}
                                                </div>
                                            </div>

                                            {/* P2 */}
                                            <ReactMarkdown>{t("News23_P2_MD")}</ReactMarkdown>

                                            {/* IMG 2 & IMG 3 */}
                                            <div style={{ textAlign: "center", margin: "23px 0" }}>
                                                <div style={{ display: "flex", justifyContent: "center", gap: 0, flexWrap: "wrap" }}>
                                                    <img
                                                        src={news23_2}
                                                        alt={t("News23_IMG2_DESC")}
                                                        style={{ maxWidth: "50%", height: "auto" }}
                                                    />
                                                    <img
                                                        src={news23_3}
                                                        alt={t("News23_IMG3_DESC")}
                                                        style={{ maxWidth: "50%", height: "auto" }}
                                                    />
                                                </div>

                                                <div style={{ marginTop: "10px", fontStyle: "italic", color: "#555" }}>
                                                    {t("News23_IMG3_DESC")}
                                                </div>
                                            </div>



                                            {/* P4 */}
                                            <ReactMarkdown>{t("News23_P4_MD")}</ReactMarkdown>

                                            {/* IMG 4 & IMG 5*/}
                                            <div style={{ textAlign: "center", margin: "23px 0" }}>
                                                <div style={{ display: "flex", justifyContent: "center", gap: 0, flexWrap: "wrap" }}>
                                                    <img
                                                        src={news23_4}
                                                        alt={t("News23_IMG4_DESC")}
                                                        style={{ maxWidth: "50%", height: "auto" }}
                                                    />
                                                    <img
                                                        src={news23_5}
                                                        alt={t("News23_IMG5_DESC")}
                                                        style={{ maxWidth: "50%", height: "auto" }}

                                                    />
                                                </div>

                                                <div style={{ marginTop: "10px", fontStyle: "italic", color: "#555" }}>
                                                    {t("News23_IMG5_DESC")}
                                                </div>
                                            </div>

                                            {/* P6 */}
                                            <ReactMarkdown>{t("News23_P6_MD")}</ReactMarkdown>

                                            {/* IMG 6 */}
                                            <div style={{ textAlign: "center", margin: "23px 0" }}>
                                                <img
                                                    src={news23_6}
                                                    alt={t("News23_IMG6_DESC")}
                                                />
                                                <div style={{ marginTop: "10px", fontStyle: "italic", color: "#555" }}>
                                                    {t("News23_IMG6_DESC")}
                                                </div>
                                            </div>

                                            {/* P7 */}
                                            <ReactMarkdown>{t("News23_P7_MD")}</ReactMarkdown>

                                            {/* IMG 7 */}
                                            <div style={{ textAlign: "center", margin: "23px 0" }}>
                                                <img
                                                    src={news23_7}
                                                    alt={t("News23_IMG7_DESC")}
                                                />
                                                <div style={{ marginTop: "10px", fontStyle: "italic", color: "#555" }}>
                                                    {t("News23_IMG7_DESC")}
                                                </div>
                                            </div>

                                            {/* P8 */}
                                            <ReactMarkdown>{t("News23_P8_MD")}</ReactMarkdown>

                                            {/* IMG 8 */}
                                            <div style={{ textAlign: "center", margin: "23px 0" }}>
                                                <img
                                                    src={news23_8}
                                                    alt={t("News23_IMG8_DESC")}
                                                />
                                                <div style={{ marginTop: "10px", fontStyle: "italic", color: "#555" }}>
                                                    {t("News23_IMG8_DESC")}
                                                </div>
                                            </div>

                                            {/* P9 */}
                                            <ReactMarkdown>{t("News23_P9_MD")}</ReactMarkdown>

                                            {/* IMG 9 */}
                                            <div style={{ textAlign: "center", margin: "23px 0" }}>
                                                <img
                                                    src={news23_9}
                                                    alt={t("News23_IMG9_DESC")}
                                                />
                                                <div style={{ marginTop: "10px", fontStyle: "italic", color: "#555" }}>
                                                    {t("News23_IMG9_DESC")}
                                                </div>
                                            </div>

                                            {/* P10 */}
                                            <ReactMarkdown>{t("News23_P10_MD")}</ReactMarkdown>

                                            {/* IMG 10 */}
                                            <div style={{ textAlign: "center", margin: "23px 0" }}>
                                                <img
                                                    src={news23_10}
                                                    alt={t("News23_IMG10_DESC")}
                                                />
                                                <div style={{ marginTop: "10px", fontStyle: "italic", color: "#555" }}>
                                                    {t("News23_IMG10_DESC")}
                                                </div>
                                            </div>

                                            {/* P11 */}
                                            <ReactMarkdown>{t("News23_P11_MD")}</ReactMarkdown>

                                            {/* IMG 11 */}
                                            <div style={{ textAlign: "center", margin: "23px 0" }}>
                                                <img
                                                    src={news23_11}
                                                    alt={t("News23_IMG11_DESC")}
                                                />
                                                <div style={{ marginTop: "11px", fontStyle: "italic", color: "#555" }}>
                                                    {t("News23_IMG11_DESC")}
                                                </div>
                                            </div>

                                            {/* P12 */}
                                            <ReactMarkdown>{t("News23_P12_MD")}</ReactMarkdown>

                                            {/* IMG 12 & IMG 13 */}
                                            <div style={{ textAlign: "center", margin: "23px 0" }}>
                                                <div style={{ display: "flex", justifyContent: "center", gap: 0, flexWrap: "wrap" }}>
                                                    <img
                                                        src={news23_12}
                                                        alt={t("News23_IMG12_DESC")}
                                                        style={{ maxWidth: "50%", height: "auto" }}
                                                    />
                                                    <img
                                                        src={news23_13}
                                                        alt={t("News23_IMG13_DESC")}
                                                        style={{ maxWidth: "50%", height: "auto" }}
                                                    />
                                                </div>
                                                <div style={{ marginTop: "13px", fontStyle: "italic", color: "#555" }}>
                                                    {t("News23_IMG13_DESC")}
                                                </div>
                                            </div>

                                            {/* P14 */}
                                            <ReactMarkdown>{t("News23_P14_MD")}</ReactMarkdown>

                                            {/* IMG 14 */}
                                            <div style={{ textAlign: "center", margin: "23px 0" }}>
                                                <img
                                                    src={news23_14}
                                                    alt={t("News23_IMG14_DESC")}
                                                />
                                                <div style={{ marginTop: "14px", fontStyle: "italic", color: "#555" }}>
                                                    {t("News23_IMG14_DESC")}
                                                </div>
                                            </div>

                                            {/* P15 */}
                                            <ReactMarkdown>{t("News23_P15_MD")}</ReactMarkdown>

                                            {/* IMG 15 */}
                                            <div style={{ textAlign: "center", margin: "23px 0" }}>
                                                <img
                                                    src={news23_15}
                                                    alt={t("News23_IMG15_DESC")}
                                                />
                                                <div style={{ marginTop: "15px", fontStyle: "italic", color: "#555" }}>
                                                    {t("News23_IMG15_DESC")}
                                                </div>
                                            </div>

                                            {/* P16 */}
                                            <ReactMarkdown>{t("News23_P16_MD")}</ReactMarkdown>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>

            </>

        );
    }
}

export default news23 = withTranslation()(news23);
